<template>
    <input 
        type="tel" 
        :value="displayValue" 
        @input="onInput"
        class="form-control text-right"
    />
</template>

<script>
export default {
    name: 'MoneyInput',
    props: {
        value: {
            type: [Number, String],
            default: 0
        }
    },
    computed: {
        displayValue() {
             if (this.value === '' || this.value === null || this.value === undefined) return '';
             return this.format(this.value);
        }
    },
    methods: {
        format(num) {
            return new Intl.NumberFormat('vi-VN').format(num);
        },
        onInput(e) {
            const val = e.target.value;
            // Allow only digits
            const raw = val.replace(/[^0-9]/g, '');
            const num = raw ? parseInt(raw, 10) : 0;
            
            // Emit number
            this.$emit('input', num);

            // Simple cursor handling: if we are typing at the end, it's fine.
            // If editing in middle, it jumps to end. 
            // For this use case (amounts), usually ok.
            
            // Force update the input value immediately to properly formatted string
            // This prevents "flickering" of raw numbers
            const formatted = this.format(num);
            if (val !== formatted) {
                 e.target.value = formatted;
            }
        }
    }
}
</script>

<style scoped>
input {
    font-variant-numeric: tabular-nums;
}
</style>
